import React, { useEffect } from 'react'
import { IWorksheetCard } from './worksheetCard/interfaces';
import * as S from './wsLimitReachedStyle'; 
import CrossButton from './cross-icon.svg';
import WSIllustration from './ws-illustration.svg';
import GreenTick from './green-tick.svg';
import PrintableWorksheetsEvents from 'printableWorksheets/events';
import { freeWsDownloadLeft, isFlutterUser } from 'apps/teacher/config/common';

declare let window: any;
interface IWSLimitReachedPopupProps {
    worksheetDetails: IWorksheetCard;
    setShowLimitReachedPopup: (value: boolean) => void;
}

const WSLimitReachedPopup: React.FC<IWSLimitReachedPopupProps> = (props) => {
    useEffect(() => {
        const eventProps = {
            from: 'Close',
            freeWorksheetsLeftCount: freeWsDownloadLeft(),
            contentType: 'Worksheets'
        }
        PrintableWorksheetsEvents.viewedSubscribePopup(eventProps);
    },[]);
    const popupCloseHandler = () => {
        const eventProps = {
            clickedOn: 'Cross',
            freeWorksheetsLeftCount: freeWsDownloadLeft(),
        }
        props.setShowLimitReachedPopup(false);
        if(window.parent.triggerIsFlutterHeaderClickDisabled) {
            window.parent.triggerIsFlutterHeaderClickDisabled();
        }
        PrintableWorksheetsEvents.interactedSubscribePopup(eventProps);
    }

    const onCtaClickHandler = () => {
        const eventProps = {
            clickedOn: 'Unlock CTA',
            freeWorksheetsLeftCount: freeWsDownloadLeft(),
        }
        isFlutterUser() ?
        window.parent.parent.location.href = '/dashboard#/purchase?source=printables&limit=0' :
        location.hash = '/purchase?source=printables&limit=0';
        PrintableWorksheetsEvents.interactedSubscribePopup(eventProps);
    }

    return (
        <S.PopupOverlay>
            <S.PopupWrapper>
                <S.CrossButton onClick={popupCloseHandler}>
                    <CrossButton />
                </S.CrossButton>
                <S.PopupHeader>You have no free worksheets left today</S.PopupHeader>
                <S.PopupDetailsWrapper>
                    <S.WSImageWrapper>
                        <S.WSImage>
                            <WSIllustration/>
                            <img src={props.worksheetDetails.image_url} alt="worksheetImage"/>
                        </S.WSImage>
                    </S.WSImageWrapper>
                    <S.TextWrapper>
                        <S.ListHeader>Start your 7-day free trial to get:</S.ListHeader>
                        <S.ListBody>
                            <S.ListItem>
                                <S.ListIcon>
                                    <GreenTick/>
                                </S.ListIcon>
                                <S.ListText>Full access to <strong>4400+ </strong> Math & Reading worksheets</S.ListText>
                            </S.ListItem>
                            <S.ListItem>
                                <S.ListIcon>
                                    <GreenTick/>
                                </S.ListIcon>
                                <S.ListText><strong>4000+ </strong> curriculum aligned games & activities</S.ListText>
                            </S.ListItem>
                            <S.ListItem>
                                <S.ListIcon>
                                    <GreenTick/>
                                </S.ListIcon>
                                <S.ListText>Comprehensive weekly progress reports</S.ListText>
                            </S.ListItem>
                        </S.ListBody>
                    </S.TextWrapper>
                </S.PopupDetailsWrapper>
                <S.CtaButton onClick={onCtaClickHandler}>Start free trial for unlimited downloads</S.CtaButton>
                <S.FooterText>You won't be charged upfront</S.FooterText>
            </S.PopupWrapper>
        </S.PopupOverlay>
    ) 
}

export default WSLimitReachedPopup